module.exports = __webpack_public_path__ + "public/img/banner3.282634ab.png";